export const environment = {
  production: false,
  url: 'https://function-portaldiplomas-dev.azurewebsites.net/api',
  apptoken: 'EWUKQbUiQU28vqSAS7YN'
};
